import { render } from "./WaiverSetup.vue?vue&type=template&id=405b44a4&scoped=true"
import script from "./WaiverSetup.vue?vue&type=script&lang=js"
export * from "./WaiverSetup.vue?vue&type=script&lang=js"

import "./WaiverSetup.vue?vue&type=style&index=0&id=405b44a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-405b44a4"]])

export default __exports__